import React from 'react';
import { BreadcrumbStateInfo, UIActions, UIActionsContext } from '../../../data-catalog-shared';

export type BreadcrumbsUpdaterProps = {
  readonly breadcrumbs: ReadonlyArray<BreadcrumbStateInfo>;
};

export class BreadcrumbsUpdater extends React.Component<BreadcrumbsUpdaterProps> {

  public override render() {
    return (
      <UIActionsContext.Consumer>
        {uiActions =>
          <BreadcrumbsUIActionsUpdater breadcrumbs={this.props.breadcrumbs} uiActions={uiActions} />
        }
      </UIActionsContext.Consumer>
    );
  }

}

type BreadcrumbsUIActionsUpdaterProps = {
  readonly breadcrumbs: ReadonlyArray<BreadcrumbStateInfo>;
  readonly uiActions: UIActions;
};

class BreadcrumbsUIActionsUpdater extends React.Component<BreadcrumbsUIActionsUpdaterProps> {

  public override componentDidMount() {
    this.updateBreadcrumbs();
  }

  public override componentDidUpdate(prevProps: BreadcrumbsUIActionsUpdaterProps) {
    if (this.props.breadcrumbs !== prevProps.breadcrumbs || this.props.uiActions !== prevProps.uiActions) {
      this.updateBreadcrumbs();
    }
  }

  private updateBreadcrumbs() {
    const breadcrumbs = this.props.breadcrumbs;
    this.props.uiActions.updateBreadcrumbs(breadcrumbs);
    const breadcrumbsLength = breadcrumbs.length;
    if (breadcrumbsLength > 0) {
      const lastBreadcrumb = breadcrumbs[breadcrumbsLength - 1];
      const lastBreadcrumbHref = lastBreadcrumb.href;
      if (lastBreadcrumbHref) {
        this.props.uiActions.updateBreadcrumbHref(lastBreadcrumbHref);
      }
    }
  }

  public override render() {
    return null;
  }

}
